import React from "react";
import { type DynamicIslandAnimationPhase } from "./animation/dynamicIslandAnimation.types";
import DynamicIslandPresenceShell from "./animation/DynamicIslandPresenceShell";
import { type DynamicIslandHostContext } from "./dynamicIsland.registry";
import { type DynamicIslandPayload } from "./dynamicIsland.types";

interface DynamicIslandProps {

    /** Active payload to render (one at a time). */
    "payload": DynamicIslandPayload | undefined;

    /** Whether dark UI palette is active. */
    "isDarkUi": boolean;

    /** Host capabilities for variant-owned interaction handlers. */
    "hostContext": DynamicIslandHostContext;

    /** Notified when FAB row should reserve center column space (open or exit in progress). */
    "onLayoutOccupancyChange"?: ( occupied: boolean ) => void;

    /** Optional animation phase callback. */
    "onPhaseChange"?: ( phase: DynamicIslandAnimationPhase ) => void;
}

/**
 * Dynamic Island shell — animated presence + variant dispatch.
 * User interactions are handled entirely inside each variant component.
 *
 * @param props Component props.
 * @returns Animated variant content or null when disabled and empty.
 */
const DynamicIsland: React.FC<DynamicIslandProps> = ( {
    payload,
    isDarkUi,
    hostContext,
    onLayoutOccupancyChange,
    onPhaseChange,
} ) => {
    return (
        <DynamicIslandPresenceShell
            hostContext={hostContext}
            isDarkUi={isDarkUi}
            onLayoutOccupancyChange={onLayoutOccupancyChange}
            onPhaseChange={onPhaseChange}
            payload={payload}
        />
    );
};

export default DynamicIsland;
